import React, { useState } from "react";
import FilterChipDisplay from "../../../Filtering/FilterChipDisplay";
import ScorecardNameFiltersDialog from "./ScorecardNameFiltersDialog";
import ScorecardFiltersViewModel from "../../Viewmodels/ScorecardFiltersViewModel";


interface IScorecardNameFiltersProps {
    name: string;
    changeFilter: (filterName: keyof ScorecardFiltersViewModel, newValue: any) => void;
}

export default function ScorecardNameFilters({ name, changeFilter }: IScorecardNameFiltersProps) {
    const [dialogOpen, setDialogOpen] = useState(false);

    const text = `Name: ${name}`

    return (
        <>
            <FilterChipDisplay
                text={text}
                selectable
                onClick={() => setDialogOpen(true)} />
            <ScorecardNameFiltersDialog
                open={dialogOpen}
                setOpen={setDialogOpen}
                currentName={name}
                changeFilter={changeFilter} />
        </>
    )
}